import { render } from "./PaysheetTabs.vue?vue&type=template&id=4ffd6662"
import script from "./PaysheetTabs.vue?vue&type=script&lang=js"
export * from "./PaysheetTabs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__